import { auth } from "services/firebase";
import { platformFetch } from "services/platformFetch";
export async function searchBookFiles(code) {
  if (!auth?.currentUser) throw new Error("Entre na sua conta para continuar.");
  const response = await platformFetch(`/api/admin/book-files?${new URLSearchParams({ code })}`, {
    headers: { Authorization: `Bearer ${await auth.currentUser.getIdToken()}` },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.message || "Não foi possível consultar os arquivos.");
  return body.books;
}
